// extracted by mini-css-extract-plugin
module.exports = {"navigation":"IntegrationPageNavigation_navigation__S_T0E","link":"IntegrationPageNavigation_link__XQtY5","link__active":"IntegrationPageNavigation_link__active__nVMm_"};